(function ($) {
  if ($('.hero-banner').length > 0) {
    setTimeout(function () {
      $(".hero-banner").addClass('active')
    }, 200);

    $(document).ready(function () {
      // Slick slider logic
      if ($(".hero-banner  .text-outer").length > 1) {
        $(".hero-banner .text-slider").slick({
          autoplay: true, // Enables autoplay
          autoplaySpeed: 5000,
          dots: true,
          arrows: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          cssEase: "linear",
        });
      }

    });
  }

  if ($('.hero-banner, .second-level-banner').length > 0) {
    $(document).ready(function () {
      function applyBreadcrumbPadding() {
        var $breadcrumb = $('.breadcrumb');
        if ($breadcrumb.length > 0) {
          var $nextSection = $breadcrumb.nextAll('section, .section, .container, div').not('.breadcrumb').first();
          if (window.innerWidth <= 767) {
            var breadcrumbHeight = $breadcrumb.outerHeight();
            var extraPadding = 40;
            var totalPadding = breadcrumbHeight + extraPadding;
            if ($nextSection.length > 0) {
              $nextSection.css('padding-top', totalPadding + 'px');
            }
          } else {
            if ($nextSection.length > 0) {
              $nextSection.css('padding-top', '');
            }
          }
        }
      }
      applyBreadcrumbPadding();

      $(window).on('load', function () {
        setTimeout(applyBreadcrumbPadding, 100);
        if (window.document.fonts && window.document.fonts.ready) {
          window.document.fonts.ready.then(function () {
            setTimeout(applyBreadcrumbPadding, 100);
          });
        }
        $('img').on('load', function () {
          setTimeout(applyBreadcrumbPadding, 100);
        });
      });
      $(window).on('resize', function () {
        setTimeout(applyBreadcrumbPadding, 100);
      });
    });
  }
})(jQuery);